<div mat-dialog-title>
  <h4 class="inline-block m-0">Configura controlli elemento</h4>
</div>
<div mat-dialog-content>
  @let field = modalData?.fieldData;
  @let fieldType = field?.type;

  <div [formGroup]="manageFieldForm" class="grid grid-cols-2 gap-6">
    @if (fieldType !== fieldTypeENUM.ACCORDION) {
      <siat-switch-field
        [label]="'Campo obbligatorio'"
        controlName="required"
        [id]="'required'"
        [labelPosition]="'after'"
        [name]="'required'"
        [formGroup]="manageFieldForm"
        class="col-span-2 mt-3"
      ></siat-switch-field>
    } @else {
      <div
        class="col-span-2 p-3 mt-3 bg-slate-50 border border-slate-200 rounded text-slate-600 text-sm"
      >
        L'obbligatorietà dell'accordion si imposta sui singoli elementi
        contenuti.
      </div>
    }

    @if (
      fieldType === fieldTypeENUM.TEXT || fieldType === fieldTypeENUM.TEXTAREA
    ) {
      <siat-input-field
        [id]="'minCharts'"
        [name]="'minCharts'"
        class="col-span-2"
        appearance="outline"
        [formGroup]="manageFieldForm"
        controlName="minCharts"
        type="number"
        [label]="'Numero minimo di caratteri'"
        [placeholder]="'Inserisci numero minimo di caratteri'"
      ></siat-input-field>
      <siat-input-field
        [id]="'maxCharts'"
        [name]="'maxCharts'"
        appearance="outline"
        class="col-span-2"
        [formGroup]="manageFieldForm"
        controlName="maxCharts"
        type="number"
        [label]="'Numero massimo di caratteri'"
        [placeholder]="'Inserisci numero massimo di caratteri'"
      ></siat-input-field>
    }

    @if (fieldType === fieldTypeENUM.NUMBER) {
      <siat-input-field
        [id]="field?.id + 'min'"
        [name]="field?.id + 'min'"
        appearance="outline"
        [formGroup]="manageFieldForm"
        controlName="min"
        type="number"
        class="col-span-1"
        [label]="'Valore minimo'"
        [placeholder]="'Inserisci valore minimo'"
      ></siat-input-field>
      <siat-input-field
        [id]="field?.id + 'max'"
        [name]="field?.id + 'max'"
        appearance="outline"
        [formGroup]="manageFieldForm"
        controlName="max"
        type="number"
        class="col-span-1"
        [label]="'Valore massimo'"
        [placeholder]="'Inserisci valore massimo'"
      ></siat-input-field>
    }

    <div class="col-span-2 mt-1">
      <siat-switch-field
        [label]="'Mostra questo campo in base al valore di un altro'"
        controlName="hasCondition"
        [id]="'hasCondition'"
        [formGroup]="manageFieldForm"
        class="block"
      ></siat-switch-field>

      @if (availableFieldsForCondition.length === 0) {
        <div
          class="p-3 mt-3 bg-slate-50 border border-slate-200 rounded text-slate-500 text-sm"
        >
          Non ci sono altri campi validi nel form a cui condizionare questo
          elemento. Compila le informazioni degli altri campi per abilitare
          questa funzione.
        </div>
      }

      @if (manageFieldForm.get('hasCondition')?.value) {
        <div
          class="grid grid-cols-2 gap-4 mt-3 p-4 bg-slate-50 border border-slate-200 rounded-lg col-span-2"
        >
          <siat-select-field
            [formGroup]="manageFieldForm"
            controlName="conditionFieldId"
            [items]="availableFieldsForCondition"
            id="conditionFieldId"
            label="Seleziona il campo scatenante"
            placeholder="Scegli un campo"
            class="col-span-2"
          ></siat-select-field>

          @if (selectedConditionField) {
            @let condType = selectedConditionField.type;

            @if (
              condType === fieldTypeENUM.SELECT ||
              condType === fieldTypeENUM.RADIOBUTTON ||
              condType === fieldTypeENUM.CHECKBOX ||
              condType === fieldTypeENUM.PRIORITY ||
              condType === fieldTypeENUM.TOGGLE
            ) {
              @if (conditionValueOptions.length === 0) {
                <div
                  class="col-span-2 p-2 bg-orange-50 text-orange-700 text-xs border border-orange-200 rounded"
                >
                  Il campo selezionato non ha ancora opzioni valide con un nome.
                  Compila le opzioni del campo padre per poterlo usare come
                  condizione.
                </div>
              } @else {
                <siat-select-field
                  [formGroup]="manageFieldForm"
                  controlName="conditionValue"
                  [items]="conditionValueOptions"
                  id="conditionValue"
                  label="Quando il suo valore è..."
                  class="col-span-2"
                  placeholder="Scegli un'opzione"
                ></siat-select-field>
              }
            } @else if (condType === fieldTypeENUM.NUMBER) {
              <siat-input-field
                [formGroup]="manageFieldForm"
                controlName="conditionValue"
                id="conditionValue"
                type="number"
                label="Quando il numero è uguale a..."
                [placeholder]="'Inserisci un numero'"
                class="col-span-2"
              ></siat-input-field>
            } @else {
              <siat-input-field
                [formGroup]="manageFieldForm"
                controlName="conditionValue"
                id="conditionValue"
                type="text"
                placeholder="Inserisci un testo"
                label="Quando il testo scritto è uguale a..."
                class="col-span-2"
              ></siat-input-field>
            }
          }
        </div>
      }
    </div>
  </div>

  <div matDialogActions class="pr-0! mt-4">
    <button
      type="button"
      matButton="tonal"
      [attr.aria-label]="'Annulla'"
      (click)="closeModal()"
      class="mr-2"
    >
      Annulla
    </button>
    <button
      type="submit"
      matButton="filled"
      [attr.aria-label]="'Salva'"
      (click)="confirmAndCloseModal()"
      [disabled]="
        !manageFieldForm.valid ||
        (manageFieldForm.get('hasCondition')?.value &&
          conditionValueOptions.length === 0 &&
          selectedConditionField &&
          (selectedConditionField.type === fieldTypeENUM.SELECT ||
            selectedConditionField.type === fieldTypeENUM.RADIOBUTTON ||
            selectedConditionField.type === fieldTypeENUM.CHECKBOX ||
            selectedConditionField.type === fieldTypeENUM.PRIORITY))
      "
    >
      Salva
    </button>
  </div>
</div>
